import { getDashboard } from "service/hf/dashboard";
import { useQuery } from "@tanstack/react-query";
import { useHfBranch } from "./useHfBranch";

export function useDashboard() {
  const { branch } = useHfBranch();

  const {
    data: dashboard,
    isPending: dashboardLoading,
    error: dashboardError,
    isError,
  } = useQuery({
    queryKey: ["dashboard", branch?.hfId],
    queryFn: async () => {
      if (!branch?.hfId) {
        throw new Error("No health facility selected");
      }
      return getDashboard(branch.hfId);
    },
    enabled: !!branch?.hfId,
  });

  if (isError) {
    console.log(isError);
  }

  return {
    dashboard,
    isLoading: dashboardLoading,
    error: dashboardError,
  };
}
